import c from 'classnames';
import { wrappingInputRule } from 'prosemirror-inputrules';
import { ParseSpec } from 'prosemirror-markdown';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions } from '@lyearn/lygo-core';

import { BULLET_LIST_REGEX, NODE_NAME } from './consts';
import plugins from './plugins';
import { bulletListStyles } from './styles';

export default class BulletList extends BaseExtension {
  protected _schema: NodeSpec = {
    content: 'list_item+',
    group: 'block',
    parseDOM: [{ tag: 'ul' }],
    toDOM: () => ['ul', { class: c('list-disc mt-8', bulletListStyles) }, 0],
  };

  get schema(): NodeSpec {
    return this._schema;
  }

  get name(): string {
    return NODE_NAME;
  }

  inputRules = ({ schema }: EditorOptions) => {
    return [wrappingInputRule(BULLET_LIST_REGEX, schema.nodes.bullet_list)];
  };

  parseMarkdown(): void | ParseSpec {
    return {
      block: NODE_NAME,
    };
  }

  plugins = plugins;
}
